const twoDimensionalDPProblems = [
  {
   title: "Unique Paths",
   url: "https://leetcode.com/problems/unique-paths/"
  },
  {
    title: "Minimum Path Sum",
    url: "https://leetcode.com/problems/minimum-path-sum/"
  },
  {
    title: "Longest Common Subsequence",
    url: "https://leetcode.com/problems/longest-common-subsequence/"
  },
  {
    title: "Edit Distance",
    url: "https://leetcode.com/problems/edit-distance/"
  },
  {
    title: "Maximal Square",
    url: "https://leetcode.com/problems/maximal-square/"
  }
];
export default twoDimensionalDPProblems;